import React from 'react';
import { LTText } from '@lambdatestincprivate/lt-components';
import { formatBytes } from '../format';
import styles from './states.module.css';

/** Basename for display; the full entry name is the disambiguator we pass. */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var basename = function basename(n) {
  return n.split('/').pop() || n;
};

/**
 * Pack chooser (store phase 'gh-choose'): an artifact/zip holds several
 * .evidence files — list them and let the user open one. A pick reflects
 * in ?ghEntry= so the chosen pack is reloadable and shareable.
 */
export function GhChooseScreen(_ref) {
  var ghChoose = _ref.ghChoose,
    onChoose = _ref.onChoose;
  var entries = ghChoose.entries;
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrap,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.card,
      children: [/*#__PURE__*/_jsx(LTText, {
        as: "h1",
        text: "Choose an evidence pack",
        color: "var(--lt-text-primary)",
        className: styles.heading,
        style: {
          fontSize: '20px',
          lineHeight: '28px',
          fontWeight: 600
        }
      }), /*#__PURE__*/_jsx(LTText, {
        as: "p",
        text: "This artifact holds ".concat(entries.length, " evidence packs. Open one to view its run."),
        variant: LTText.TextVariant.SUBHEADER_REGULAR,
        color: "var(--lt-text-secondary)",
        className: styles.body
      }), /*#__PURE__*/_jsx("div", {
        className: styles.chooseList,
        role: "list",
        children: entries.map(function (e) {
          return /*#__PURE__*/_jsxs("button", {
            type: "button",
            role: "listitem",
            className: styles.chooseItem,
            onClick: function onClick() {
              return onChoose(e.name);
            },
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.chooseName,
              title: e.name,
              children: basename(e.name)
            }), /*#__PURE__*/_jsx("span", {
              className: styles.chooseSize,
              children: formatBytes(e.size)
            })]
          }, e.name);
        })
      })]
    })
  });
}